import aiHeader from '../../components/dashboard/paywall/sales-activated-trial/page/images/ai-header.png';
import aiSection1 from '../../components/dashboard/paywall/sales-activated-trial/page/images/ai-section1.png';
import aiSection2 from '../../components/dashboard/paywall/sales-activated-trial/page/images/ai-section2.png';
import aiSection3 from '../../components/dashboard/paywall/sales-activated-trial/page/images/ai-section3.png';
import type { PageblockData } from '../pageblockTypes';

export const PAGEBLOCK_DATA_AI_ASSISTANT: PageblockData = {
  headerData: {
    headerText: 'Transform end user support with AI',
    subHeaderText:
      'Respond faster, reduce time spent on support, and provide end users with a seamless experience. Automate routine tasks and deliver real-time answers directly within Salesforce.',
    imgSrc: aiHeader,
    imgAlt: 'AI header',
    name: 'AI Assistant',
  },
  pageTitle: 'Empower end user self-service with Salesforce support AI assistant',
  section1: {
    imgSrc: aiSection1,
    imgAlt: 'AI section img',
    title: 'Easily troubleshoot Salesforce issues',
    content:
      'End users can quickly copy and paste error messages into the chat for instant troubleshooting, with the option to escalate to an admin if needed.',
  },
  section2: {
    imgSrc: aiSection2,
    imgAlt: 'AI section 2 img',
    title: 'Automate ticket creation and sync with your system',
    content:
      'Create and sync support ticket from within Salesforce, ensuring integration with your existing support workflows.',
  },
  section3: {
    imgSrc: aiSection3,
    imgAlt: 'AI section 3 img',
    title: 'AI-powered, admin-reviewed support',
    content:
      'Users can ask the AI-powered "Virtual Admin" questions, and all conversations are recorded for your review, giving you control and insight into the process.',
  },
};
